import { useSearch } from "../../hooks/useSearch";
import { getReservations_v2 } from "../../services/Reservations.service";
import Pagination from "../ui/table/Pagination";
import FilteredListState, { ResultCount } from "./filters/FilteredListState";
import { RESERVATION_FILTER_KEYS as KEYS } from "./filters/reservationFilters";
import useFilterParams from "./filters/useFilterParams";
import SkeletonTicket from "./SkeletonTicket";
import Ticket from "./Ticket";

const Reservations = () => {
  // useSearch reads the search, status and date range itself; the other filters ride along in
  // otherQuery. Any change to them changes the memo key, which refires the fetch;
  // ReservationFilterBar clears `pageindex` on every change so the list returns to page 1.
  const { get: param, hasFilters, clearAll } = useFilterParams();

  const { response, loading, error, handlePageChange, page, refetch } = useSearch(
    getReservations_v2,
    {
      withQuerySearch: true,
      filterSelector: KEYS.statusId,
      withFilter: true,
      withDateFrom: true,
      withDateTo: true,
      // The endpoint answers 404 when nothing matches; without this the previous results stayed
      // on screen as if they matched the new filters.
      resetResponseOnError: true,
      otherQuery: {
        filterByJourneyDate: param(KEYS.dateType) === "travel" ? "true" : "false",
        pageSize: "12",
        addOns: param(KEYS.addOns),
        operatorId: param(KEYS.operatorId),
        lineId: param(KEYS.lineId),
        paymentMethodId: param(KEYS.paymentMethodId)
      }
    }
  );

  return (
    <>
      <style>
        {`
        .ticket:before {
          clip-path: circle(70% at 100% 50%);
        }
        .ticket:after {
          clip-path: circle(70% at 0 50%);
        }
        `}
      </style>
      <div className="flex gap-4 flex-col lg:max-w-[75%] mx-auto">
        <ResultCount loading={loading} count={response?.data.totalCount} noun="rezervime" />
        <SkeletonTicket loading={loading} />
        {!loading &&
          response?.data.result.map((el) => (
            <Ticket
              key={el.uniqueJourneyId}
              {...el}
              onLuggageChange={refetch}
              onPassengersChange={refetch}
            />
          ))}
        <FilteredListState
          loading={loading}
          error={error}
          isEmpty={!response?.data.result.length}
          emptyText="Nuk u gjet asnjë rezervim me këto filtra."
          hasFilters={hasFilters}
          onClear={clearAll}
          onRetry={refetch}
          notFoundMeansEmpty
        />
      </div>
      {response?.data.totalPages ? (
        <Pagination
          onPageChange={handlePageChange}
          totalCount={response?.data?.totalCount || 0}
          length={response?.data?.result.length}
          page={page}
          pageSize={response?.data.pageSize || 12}
          viewingOf={false}
          className="border-none px-0 py-0 justify-center mt-8"
        />
      ) : null}
    </>
  );
};

export default Reservations;
